<script>
	import { page } from '$app/state';
	import { getContext } from 'svelte';
	import { fly, slide } from 'svelte/transition';

	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';

	import HeaderMenuDashboard from './HeaderMenuDashboard.svelte';
	import HeaderMenuItem from './HeaderMenuItem.svelte';
	import HeaderMenuLogin from './HeaderMenuLogin.svelte';
	import HeaderMenuMobile from './HeaderMenuMobile.svelte';

	import { howto, products, solutions } from './header-data';

	let userData = getContext('userData');

	let signedIn = $derived(userData.signedIn);
	let signingIn = $derived(page.url.pathname.startsWith('/signin'));
	let signingUp = $derived(
		page.url.pathname.startsWith('/how-to/get-indow-inserts'),
	);
	let isDashboard = $derived(signedIn && page.url.pathname.startsWith('/my'));

	let showGetEstimateButton = $derived(
		!signingIn && !signingUp && !isDashboard,
	);

	let innerWidth = $state();

	let getEstimateTransition = (node) => {
		return innerWidth < 768
			? fly(node, { y: '-150%' })
			: slide(node, { axis: 'x' });
	};
</script>

<svelte:window bind:innerWidth />
<ul class="flex size-full list-none justify-end gap-px select-none">
	<!-- Solutions Menu -->
	<li
		class="
    hidden
    md:block
  "
	>
		<HeaderMenuItem title="Solutions" route="/solutions/window-insulation">
			<div
				class="
      w-lg p-6
      lg:w-2xl
    "
			>
				{#each solutions as { heading, items }, index (index)}
					<p class="m-0 p-0 text-2xl font-bold text-indow-blue">{heading}</p>
					<ul
						class="grid list-none grid-cols-4 text-center leading-5 font-medium"
					>
						{#each items as { title, href, src }, index2 (index2)}
							<li class="hover:bg-gray-100">
								<a
									class="m-0 grid h-full gap-1 p-2 text-inherit no-underline"
									{href}
								>
									<span class="h-20 w-auto text-indow-blue">
										{@render src()}
									</span>
									{title}
								</a>
							</li>
						{/each}
					</ul>
				{/each}
				<Button href="/solutions/window-insulation" color="blue"
					>VIEW ALL</Button
				>
			</div>
		</HeaderMenuItem>
	</li>

	<!-- Products Menu -->
	<li
		class="
    hidden
    md:block
  "
	>
		<HeaderMenuItem title="Products" route="/products/indowone-window-inserts">
			<div
				class="
      w-lg p-6
      lg:w-xl
    "
			>
				{#each products as { heading, items }, index (index)}
					<p class="m-0 p-0 text-2xl font-bold text-indow-blue">{heading}</p>
					<ul
						class="grid list-none grid-cols-3 text-center leading-5 font-medium"
					>
						{#each items as { title, href, thumbnail: src }, index2 (index2)}
							<li class="hover:bg-gray-100">
								<a
									class="m-0 grid h-full gap-3 p-2 text-inherit no-underline"
									{href}
								>
									<Image {src} class="h-40" />
									{title}
								</a>
							</li>
						{/each}
					</ul>
				{/each}
				<Button href="/products/indowone-window-inserts" color="blue"
					>VIEW ALL</Button
				>
			</div>
		</HeaderMenuItem>
	</li>

	<!-- How-To Menu -->
	<li
		class="
    hidden whitespace-nowrap
    md:block
  "
	>
		<HeaderMenuItem title="How To" route="/how-to">
			<ul
				class="
      relative block w-full list-none pt-3 text-left font-medium
      whitespace-nowrap
    "
			>
				{#each howto as { title, href }, index (index)}
					<li class="m-0 block w-full">
						<a
							class="
         m-0 block w-full px-6 py-4 text-inherit no-underline
         hover:bg-gray-100
       "
							{href}>{title}</a
						>
					</li>
				{/each}
			</ul>
		</HeaderMenuItem>
	</li>

	<!-- Pricing Link -->
	<li
		class="
    hidden grow
    md:block
  "
	>
		<HeaderMenuItem
			title="Pricing"
			href="/products/window-insert-cost"
			class="h-full"
		/>
	</li>

	<!-- Get Estimate Button -->

	<li
		class="
    place-content-center text-center
    max-md:grow
    max-xs:hidden
  "
	>
		<div
			transition:getEstimateTransition
			class="flex content-center justify-center"
		>
			<HeaderMenuItem
				button
				title="GET ESTIMATE"
				href="/free-estimate"
				class="whitespace-nowrap"
				active={showGetEstimateButton}
			/>
		</div>
	</li>

	<!-- Mobile Menu -->
	<li
		class="
    h-full place-content-center pl-0
    md:hidden md:pl-6
  "
	>
		<HeaderMenuMobile />
	</li>

	<!-- Profile Icon Menu-->
	<li
		class="
    relative pl-4
    sm:pl-6
  "
	>
		{#if signedIn}
			<HeaderMenuDashboard active={isDashboard} />
		{:else}
			<HeaderMenuLogin active={signingIn || signingUp} />
		{/if}
	</li>
</ul>
